import './froala.module.scss';

// Require Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/plugins.pkgd.min.js';

// Require Editor CSS files.
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';

// Require Font Awesome.
// import 'font-awesome/css/font-awesome.css';

import FroalaEditor from 'react-froala-wysiwyg';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

/* eslint-disable-next-line */
export interface FroalaProps {
  //imageUploadUrl: string,
  model: any,
  onModelChanged?: (...args: any[]) => void,
  onBlur?: (...args: any[]) => void,
  minHeight?: number
  maxHeight?: number
}

export function Froala(props: FroalaProps) {
  const { t } = useTranslation();
  const [editorInitialized, setEditorInitialized] = useState(false);
  const config = {
    placeholderText: t('froala.addTextOrImages'),
    charCounterCount: false,
    attribution: false,
    toolbarButtons: [
      'fontSize',
      "bold",
      "italic",
      "underline",
      "subscript",
      "superscript",
      "insertTable",
      "insertImage",
      'align',
      'formatUL',
      "insertLink",
      'fullscreen',
      'backgroundColor',
      'background'
    ],
    fontFamilySelection: true,
    fontSize: ['8', '10', '12', '14', '16', '18', '30', '60', '96'],
    fontSizeSelection: true,
    paragraphFormatSelection: false,
    quickInsertTags: [''],
    tableInsertHelper: false,
    language: 'nb',
    requestWithCORS: true,
    heightMin: props.minHeight || 200,
    heightMax: props.maxHeight || 205,
    pastePlain: true,
    imageUpload: true,
    //imageUploadURL: props.imageUploadUrl,
    // imageUploadURL: 'Todo::',
    imageUploadMethod: 'PUT',
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    imageUploadParams: {
      await: true,
      jobDoneNotification: true
    },
    requestHeaders: {
      'x-ms-blob-type': 'BlockBlob'
      // "Authorization": `Bearer ${window.localStorage.getItem("auth_token")}`
    },
    events: {
      'focus': function (e: any) {
        let editor: any = this;
      },
      'initialized': function (e: any, editor: any) {
        setEditorInitialized(true);
      },
      'blur': function (e: any) {
        props.onBlur && props.onBlur()
      },
      'contentChanged': function (e: any, editor: any) {
      },
      'image.beforeUpload': function (e: any, images: any) {
        let editor: any = this;
        // editor.opts.imageUploadURL = editor.opts.imageUploadURL.replace("{filename}", e[0].name);

        if (e.length) {
          // Create a File Reader.
          let reader = new FileReader();
          // Set the reader to insert images when they are loaded.
          reader.onload = function (event: any) {
            let result = event.target.result;
            editor.image.insert(result, null, null, editor.image.get());
          };
          // Read image as base64.
          reader.readAsDataURL(e[0]);
        }
        editor.popups.hideAll();
        // Stop default upload chain.
        return false;
      },
      'image.uploaded': function (e: any, editor: any, response: any) {
      },
      'image.inserted': function ($img: any, response: any) {
      },
      'image.replaced': function ($img: any, response: any) {
      },
      'image.removed': function ($img: any, editor: any, selector: any) {
      },
      'imageManager.error': function (error: any, response: any) {
      },
      'image.error': function (error: any, response: any) {
        // Bad link.
        if (error.code == 1) { }
        // No link in upload response.
        else if (error.code == 2) { }
        // Error during image upload.
        else if (error.code == 3) { }
        // Parsing response failed.
        else if (error.code == 4) { }
        // Image too text-large.
        else if (error.code == 5) { }
        // Invalid image type.
        else if (error.code == 6) { }
        // Image can be uploaded only to same domain in IE 8 and IE 9.
        else if (error.code == 7) { }
        // Response contains the original server response to the request if available.
      }
    },
    key: "7MD3aC3E3A5D5E4D3xROKLJKYHROLDXDRE1b1YYGRi1Bd1C4F4B3A2G3A14A15A12A4C3=="
  }

  return (
    <FroalaEditor
      tag='textarea'
      config={config}
      model={editorInitialized ? (props.model ?? '') : undefined}
      onModelChange={props.onModelChanged}
    />
  );
}

export default Froala;